(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shoppable-gallery"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const tagName = 'twojour-shoppable-gallery';
    if (customElements.get(tagName)) return;

    // Attribute JSON avoids delimiter collisions in vendors/category labels.
    const valuesFrom = (raw) => {
      try {
        const values = JSON.parse(raw || '[]');
        return Array.isArray(values)
          ? [...new Set(values.filter((value) => typeof value === 'string').map((value) => value.trim()).filter(Boolean))]
          : [];
      } catch {
        return [];
      }
    };

    const dateFrom = (raw) => {
      const value = (raw || '').trim();
      if (!/^\d{4}-\d{2}-\d{2}$/.test(value)) return null;
      const timestamp = Date.parse(value + 'T00:00:00Z');
      if (!Number.isFinite(timestamp)) return null;
      // Reject impossible dates such as February 30, which Date.parse normalizes.
      return new Date(timestamp).toISOString().slice(0, 10) === value ? timestamp : null;
    };

    customElements.define(tagName, class extends HTMLElement {
      connectedCallback() {
        // Also handles insertion before the browser has parsed the children.
        this.frame = requestAnimationFrame(() => this.initialize());
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        cancelAnimationFrame(this.previewFrame);
        this.closePreview();
        this.previewInView = null;
        this.pointerActivation = null;
        this.events?.abort();
        this.events = null;
      }

      initialize() {
        if (this.events || !this.isConnected) return;
        this.controls = this.querySelector('[data-gallery-controls]');
        this.list = this.querySelector('[data-gallery-items]');
        this.brand = this.querySelector('[data-gallery-brand]');
        this.category = this.querySelector('[data-gallery-category]');
        this.sort = this.querySelector('[data-gallery-sort]');
        this.reset = this.querySelector('[data-gallery-reset]');
        this.empty = this.querySelector('[data-gallery-empty]');
        this.status = this.querySelector('[data-gallery-status]');
        if (![this.controls, this.list, this.brand, this.category, this.sort, this.reset, this.empty, this.status].every(Boolean)) return;

        this.items = Array.from(this.list.querySelectorAll('[data-gallery-item]'), (element, index) => ({
          element,
          order: Number.isFinite(Number(element.dataset.galleryOrder)) ? Number(element.dataset.galleryOrder) : index,
          vendors: valuesFrom(element.dataset.galleryVendors),
          categories: valuesFrom(element.dataset.galleryCategories),
          date: dateFrom(element.dataset.galleryDate)
        })).sort((a, b) => a.order - b.order);
        if (!this.items.length) return;

        this.populate(this.brand, this.items.flatMap((item) => item.vendors));
        this.populate(this.category, this.items.flatMap((item) => item.categories));
        this.isEditor = this.dataset.galleryEditor === 'true';
        // Section IDs survive normal page loads and keep separate instances independent.
        this.queryPrefix = `gallery_${this.dataset.gallerySection}_`;
        this.events = new AbortController();
        const eventOptions = { signal: this.events.signal };
        if (this.dataset.galleryPreviews === 'true') this.initializePreviews(eventOptions);
        this.controls.addEventListener('change', () => {
          this.apply();
          this.writeURL();
        }, eventOptions);
        this.reset.addEventListener('click', () => {
          this.brand.value = '';
          this.category.value = '';
          this.apply();
          this.writeURL();
        }, eventOptions);
        window.addEventListener('popstate', () => {
          if (!this.isEditor) this.readURL();
          this.apply();
        }, eventOptions);
        window.addEventListener('pageshow', () => {
          if (!this.isEditor) this.readURL();
          this.apply(false);
        }, eventOptions);
        this.addEventListener('shopify:block:select', (event) => {
          if (!this.isEditor) return;
          const block = this.items.find((item) => item.element.dataset.galleryBlock === event.detail?.blockId);
          if (!block) return;
          this.brand.value = '';
          this.category.value = '';
          this.sort.value = 'featured';
          this.apply();
          block.element.scrollIntoView({ block: 'nearest', behavior: 'auto' });
        }, eventOptions);
        if (!this.isEditor) this.readURL();
        this.apply(false);
        this.controls.hidden = false;
      }

      initializePreviews(eventOptions) {
        const hotspotFrom = (target) => {
          const link = target instanceof Element ? target.closest('.shoppable-gallery__hotspot') : null;
          return link?.closest(tagName) === this ? link : null;
        };
        this.addEventListener('pointerdown', (event) => {
          this.pointerActivation = { link: hotspotFrom(event.target), type: event.pointerType, time: event.timeStamp };
        }, eventOptions);
        this.addEventListener('click', (event) => {
          const link = hotspotFrom(event.target);
          const pointer = this.pointerActivation;
          this.pointerActivation = null;
          // detail 0 includes keyboard/assistive activation: always keep normal link behaviour.
          if (!link || event.defaultPrevented || event.detail === 0 || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          const pointerType = event.pointerType || (pointer?.link === link && event.timeStamp - pointer.time < 1500 ? pointer.type : '');
          const touch = pointerType === 'touch' || pointerType === 'pen' || (pointerType === 'mouse' && matchMedia('(pointer: coarse)').matches);
          if (!touch || this.openPreview === link) return;
          event.preventDefault();
          this.closePreview();
          // Coordinate only touch-open cards across section instances; no shared global state.
          document.dispatchEvent(new CustomEvent('twojour-gallery:preview-open', { detail: this }));
          this.openPreview = link;
          link.removeAttribute('data-preview-dismissed');
          link.setAttribute('data-preview-open', '');
          this.positionPreview(link);
        }, eventOptions);
        document.addEventListener('twojour-gallery:preview-open', (event) => {
          if (event.detail !== this) this.closePreview();
        }, eventOptions);
        document.addEventListener('pointerdown', (event) => {
          if (this.openPreview && !this.openPreview.contains(event.target)) this.closePreview();
        }, eventOptions);
        this.addEventListener('pointerover', (event) => {
          const link = hotspotFrom(event.target);
          if (!link || link.contains(event.relatedTarget) || event.pointerType === 'touch') return;
          link.removeAttribute('data-preview-dismissed');
          this.positionPreview(link);
        }, eventOptions);
        this.addEventListener('focusin', (event) => {
          const link = hotspotFrom(event.target);
          if (this.openPreview !== link) this.closePreview();
          if (!link) return;
          link.removeAttribute('data-preview-dismissed');
          this.positionPreview(link);
        }, eventOptions);
        const leave = (event) => {
          const link = hotspotFrom(event.target);
          if (!link || link.contains(event.relatedTarget)) return;
          link.removeAttribute('data-preview-dismissed');
          if (this.previewInView === link && this.openPreview !== link) this.previewInView = null;
        };
        this.addEventListener('pointerout', leave, eventOptions);
        this.addEventListener('focusout', leave, eventOptions);
        document.addEventListener('keydown', (event) => {
          if (event.key !== 'Escape') return;
          const link = this.previewInView;
          this.closePreview();
          link?.setAttribute('data-preview-dismissed', '');
          this.previewInView = null;
        }, eventOptions);
        const reposition = () => {
          if (!this.previewInView) return;
          cancelAnimationFrame(this.previewFrame);
          this.previewFrame = requestAnimationFrame(() => this.positionPreview(this.previewInView));
        };
        window.addEventListener('resize', reposition, eventOptions);
        window.addEventListener('scroll', reposition, { ...eventOptions, passive: true });
      }

      closePreview() {
        if (!this.openPreview) return;
        this.openPreview.removeAttribute('data-preview-open');
        this.openPreview.setAttribute('data-preview-dismissed', '');
        if (this.previewInView === this.openPreview) this.previewInView = null;
        this.openPreview = null;
      }

      positionPreview(link) {
        const card = link?.querySelector('.shoppable-gallery__preview');
        if (!card || !card.getClientRects().length) return;
        this.previewInView = link;
        card.style.setProperty('--sg-preview-shift-x', '0px');
        card.style.setProperty('--sg-preview-shift-y', '0px');
        const anchor = link.getBoundingClientRect();
        const height = card.getBoundingClientRect().height;
        const viewportWidth = document.documentElement.clientWidth;
        const viewportHeight = document.documentElement.clientHeight;
        // Prefer the existing image-edge hint; flip when the viewport has more room on the other side.
        const roomAbove = anchor.top - 16;
        const roomBelow = viewportHeight - anchor.bottom - 16;
        const below = link.hasAttribute('data-tooltip-below')
          ? roomBelow >= height || roomBelow >= roomAbove
          : roomAbove < height && roomBelow > roomAbove;
        link.dataset.previewSide = below ? 'below' : 'above';
        const rect = card.getBoundingClientRect();
        const x = Math.max(16 - rect.left, Math.min(0, viewportWidth - 16 - rect.right));
        const y = Math.max(16 - rect.top, Math.min(0, viewportHeight - 16 - rect.bottom));
        card.style.setProperty('--sg-preview-shift-x', `${x}px`);
        card.style.setProperty('--sg-preview-shift-y', `${y}px`);
      }

      populate(select, values) {
        const previous = select.value;
        const unique = [...new Set(values)].sort((a, b) => a.localeCompare(b));
        select.replaceChildren(new Option('All', ''));
        unique.forEach((value) => select.add(new Option(value, value)));
        select.disabled = unique.length === 0;
        select.value = unique.includes(previous) ? previous : '';
      }

      apply(announce = true) {
        this.closePreview();
        this.previewInView = null;
        const sorted = [...this.items];
        if (this.sort.value === 'newest') {
          sorted.sort((a, b) => {
            if (a.date === null && b.date !== null) return 1;
            if (a.date !== null && b.date === null) return -1;
            return (b.date ?? 0) - (a.date ?? 0) || a.order - b.order;
          });
        }
        let visible = 0;
        // Only move existing items when order actually changes; hotspot nodes stay intact.
        const current = Array.from(this.list.querySelectorAll('[data-gallery-item]'));
        if (sorted.some((item, index) => current[index] !== item.element)) {
          sorted.forEach((item) => this.list.append(item.element));
        }
        sorted.forEach((item) => {
          const matchesBrand = !this.brand.value || item.vendors.includes(this.brand.value);
          const matchesCategory = !this.category.value || item.categories.includes(this.category.value);
          item.element.hidden = !(matchesBrand && matchesCategory);
          if (!item.element.hidden) visible += 1;
        });
        this.empty.hidden = visible !== 0;
        this.reset.disabled = !this.brand.value && !this.category.value;
        if (announce) {
          this.status.textContent = visible === 0
            ? 'No gallery images match these filters.'
            : `${visible} gallery ${visible === 1 ? 'image' : 'images'} shown.`;
        }
      }

      readURL() {
        const params = new URL(window.location.href).searchParams;
        for (const [name, select] of [['brand', this.brand], ['category', this.category]]) {
          const value = params.get(this.queryPrefix + name) || '';
          select.value = Array.from(select.options).some((option) => option.value === value) ? value : '';
        }
        this.sort.value = params.get(this.queryPrefix + 'sort') === 'newest' ? 'newest' : 'featured';
      }

      writeURL() {
        if (this.isEditor) return;
        try {
          const url = new URL(window.location.href);
          for (const [name, value] of [
            ['brand', this.brand.value],
            ['category', this.category.value],
            ['sort', this.sort.value === 'newest' ? 'newest' : '']
          ]) {
            if (value) url.searchParams.set(this.queryPrefix + name, value);
            else url.searchParams.delete(this.queryPrefix + name);
          }
          if (url.href !== window.location.href) history.pushState(history.state, '', url);
        } catch {
          // History may be unavailable inside previews; filtering still works.
        }
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
